import { ButtonGroup, FormattedMessage } from '@subaio/components'

import type {
	Handlers,
	OpportunityCarInsuranceStep,
	OpportunityCarInsuranceStepType,
} from 'containers/OpportunityCarInsurance/handlers'

import { ButtonSolid } from 'components/Buttons'
import { Card } from 'components/Card'
import { IconDocumentLoop, IconMail } from 'components/Icons'
import { Header, PointItem, PointList } from 'components/Layout'

import { Title } from '../Title'

type Props = TaggedType<OpportunityCarInsuranceStep, OpportunityCarInsuranceStepType.DataProcessing> & {
	onShowConsent: Handlers['onShowConsent']
}

export const DataProcessing = ({
	selectedInsurer,
	personalDetails,
	licensePlate,
	damageFreeYears,
	drivenDistancePerYear,
	currentCoverage,
	onShowConsent,
}: Props) => (
	<Card>
		<Header>
			<Title>
				<FormattedMessage id='opportunityCarInsurance.privacyStatement.title' defaultMessage='Data processing' />
			</Title>
		</Header>
		<PointList>
			<PointItem>
				<IconDocumentLoop />
				<FormattedMessage
					id='opportunityCarInsurance.privacyStatement.stepOne'
					defaultMessage='Based on your consent, we send your date of birth, zip code and specified car data to our comparison partner poliswijzer.nl.'
				/>
			</PointItem>
			<PointItem>
				<IconMail />
				<div>
					<p role='text'>
						<FormattedMessage
							id='opportunityCarInsurance.privacyStatement.stepTwo'
							defaultMessage='You share your data once for calculating savings. Your data will be kept for 4 weeks. This way we guarantee you get the correct premium and we can track which offer you received.'
						/>
					</p>
					<FormattedMessage
						id='opportunityCarInsurance.privacyStatement.stepTwoExtra'
						defaultMessage='If you would like to delete your data sooner, please email <a>besparen@nl.abnamro.com</a>.'
						// biome-ignore lint/a11y/useValidAnchor: We do not actually allow linking out, so this is for selecting
						values={{ a: (node) => <a style={{ userSelect: 'text' }}>{node}</a> }}
					/>
				</div>
			</PointItem>
		</PointList>
		<ButtonGroup center>
			<ButtonSolid
				label={<FormattedMessage id='opportunityCarInsurance.buttonBack' defaultMessage='Back' />}
				onClick={() =>
					onShowConsent(
						selectedInsurer,
						personalDetails,
						licensePlate,
						damageFreeYears,
						drivenDistancePerYear,
						currentCoverage,
					)
				}
			/>
		</ButtonGroup>
	</Card>
)
